var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "32", height: "32", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
    React.createElement("path", { d: "M7.3 4.5l20 20c.7.7.7 1.9 0 2.6-.7.7-1.9.7-2.6 0l-20-20c-.7-.7-.7-1.8 0-2.6.7-.7 1.9-.7 2.6 0z" }),
    React.createElement("path", { d: "M4.7 24.5l20-20c.7-.7 1.9-.7 2.6 0 .7.7.7 1.9 0 2.6l-20 20c-.7.7-1.9.7-2.6 0-.7-.7-.7-1.8 0-2.6z" })
  );
});